module.exports = __webpack_public_path__ + "img/contacttwo (2).9940c4f7.png";